<script>
import * as d3 from "d3";
import DibbleJS from "../../dibble";
import DibbleAPI from "../../api";
import ModalSlipInfo from "./SlipInfoModal.vue";

export default {
    name: "MoorageParkingMap",
    components: { ModalSlipInfo },
    data() {
        return {
            dibbleJs: DibbleJS,
            data: [],
            isShow: false,
            info: {},
            marinaId: this.$route.params.id,
            mapSvg: {
                LMM: "LM_map_custome.svg",
                LVBH: "LV_map.svg",
            },
        };
    },
    created() {
        this.getSlip(this.marinaId);
    },
    mounted() {
        let svg;
        const svgFile = require("./" + this.mapSvg[this.marinaId]);
        d3.xml(svgFile).then((data) => {
            const parent = d3.select("#svg-container");
            parent.node().append(data.documentElement);
            svg = d3.select("svg");
            const zoomHandler = d3.zoom().on("zoom", this.zoomActions);
            zoomHandler(svg);
            const g = d3.selectAll("g");
            g.on("click", (d, i, nodes) => {
                const item = d3.select(nodes[i]);
                this.clickActions(item);
            });
        });
    },

    methods: {
        getSlip() {
            DibbleJS.showLoader();
            const params = {
                request: DibbleAPI.api.getMarinaSlips,
                marina_id: this.marinaId,
            };
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                    this.data = responseData;
                    this.marinaId === "LMM"
                        ? this.getAllLMSlips(this.data)
                        : this.getAllSlips(this.data);
                } else {
                    DibbleJS.toastErrorMessage(responseData.message);
                }
            });
        },

        zoomActions() {
            const map = false;
            const xTranslate = map
                ? d3.event.transform.x - 640
                : d3.event.transform.x;
            const yTranslate = map
                ? d3.event.transform.y + 3267
                : d3.event.transform.y;
            const scale = d3.event.transform.k;
            d3.select("#main").attr(
                "transform",
                `translate(${xTranslate} ${yTranslate}) scale(${scale})`
            );
        },

        clickActions(e) {
            if (e.attr("id") && e.attr("data-name") === "slip") {
                DibbleJS.showLoader();
                const params = {
                    request: DibbleAPI.api.getSlipInfoByName,
                    marina_id: this.marinaId,
                    slip_name: e.attr("id").replace("-", ":"),
                };
                DibbleJS.callApiRequest(params, (responseData) => {
                    DibbleJS.hideLoader();
                    if (DibbleAPI.isResponseSuccess(responseData)) {
                        this.info = responseData;
                        this.isShow = true;
                    } else {
                        DibbleJS.toastErrorMessage(responseData.message);
                    }
                });
            }
        },

        getAllSlips({ slips }) {
            var gtags = d3.selectAll("g");
            const COLOR = {
                1: "#4CAF50",
                2: "#FF1744",
                3: "#F57F17",
                4: "#FF1744",
            };
            gtags.each(function () {
                var item = d3.select(this);
                if (item.attr("id") && item.attr("data-name") === "slip") {
                    const slip = slips.find(
                        (s) => s.slip_name === item.attr("id").replace("-", ":")
                    );
                    const color = slip?.is_available || 4;
                    item
                        .select("g")
                        .select("g")
                        .attr("fill", COLOR[color])
                        .attr("stroke", COLOR[color]);
                }
                item
                    .select("text")
                    .attr("fill", "#FFF")
                    .attr("cursor", "pointer");
            });
        },

        getAllLMSlips({ slips }) {
            var gtags = d3.selectAll("g");
            const COLOR = {
                1: "#4CAF50",
                2: "#FF1744",
                3: "#F57F17",
                4: "#FF1744",
            };
            gtags.each(function () {
                var item = d3.select(this);
                if (item.attr("id") && item.attr("data-name") === "slip") {
                    const slip = slips.find(
                        (s) => s.slip_name === item.attr("id").replace("-", ":")
                    );
                    const color = slip?.is_available || 4;

                    let selection = item.select("g");
                    if (!selection.empty() && selection.attr("data-attibute")) {
                        selection
                            .attr("fill", COLOR[color])
                            .attr("stroke", COLOR[color])
                            .attr("opacity", "0.63");
                        selection.select("path").style("fill", COLOR[color]);
                    } else {
                        selection = item.select("g").select("g");
                        if (!selection.empty() && selection.attr("data-attibute")) {
                            selection
                                .attr("fill", COLOR[color])
                                .attr("stroke", COLOR[color])
                                .attr("opacity", "0.63");
                        } else {
                            selection = item
                                .select("g")
                                .select("g")
                                .select("g");
                            selection.attr("fill", COLOR[color]).attr("stroke", COLOR[color]);
                        }
                    }
                }
            });
        },

        closeModal() {
            this.isShow = false;
        },
    },
};
</script>
<template src="./template/map.html"> </template>
<style lang="scss">
.container1 {
    overflow: hidden;
}

#svg-container {
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;

    svg {
        width: 100%;
        height: 100%;
    }
}

.links line {
    stroke: #999;
    stroke-opacity: 0.6;
}

.nodes circle {
    stroke: black;
    stroke-width: 0px;
}

g[data-name="slip"] {
    cursor: pointer;
}
</style>
<style lang="scss" scoped>
.order-history {
    display: flex;
    width: 100%;
    padding: 20px 30px;
    min-width: 1000px;

    p {
        font-family: 'Open Sans';
        font-style: normal;
    }

    .table-order {
        flex: 1;
        display: flex;
        flex-direction: column;

        .header-boat-info {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title-boat {
                font-weight: 700;
                letter-spacing: 0.04em;
                text-transform: capitalize;
                color: #1C5169;
                font-size: 22px;
            }

            .toggle-button {
                width: 220px;
                background: #dfdfdf;
                display: flex;
                justify-content: space-between;
                margin-top: 20px;

                opacity: 0.8;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                border-radius: 30px;
                height: 60px;

                >div {
                    width: calc(100%/3);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-sizing: border-box;

                    &:not(:last-child) {
                        border-right: 1.5px solid #fff;
                    }

                }

                p {
                    font-weight: 600;
                    font-size: 18px;
                    color: #7C7C7A;
                }

                .active-button {
                    p {
                        color: #2C94AB;
                    }

                    background: #D9D9D9 !important;
                }
            }

            .select-boat {
                display: flex;
                flex-direction: column;
                width: 200px;
                height: 50px;
                background: #c2d8dd;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                border-radius: 40px;
                padding: 15px 20px;
                box-sizing: border-box;
                position: relative;

                .icon-boat-blue {
                    width: 35px;
                }

                .boat-selected {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    p {
                        font-family: "Roboto";
                        font-style: normal;
                        font-weight: 600;
                        font-size: 18px;
                        color: #7C7C7A;
                    }
                }
            }
        }
    }

    .map-container {
        width: 100%;
        margin-bottom: 30px;
        background: #ECEDEE;

        border-radius: 40px;
        box-shadow: 0px 15px 20px -6px rgba(16, 24, 40, 0.15);
    }

}
</style>
